<template>
    <div class="plan-medical plan-medical__rx">
        <div class="notes" v-if="SsoButtonText(healthplanD.provider) && (healthplanD.provider!=='OptumRx' || envoptum=='on' )">
            <p>Please note, you will be navigating to another site.</p>
            <a
                @click.prevent="healthplanD.provider === 'OptumRx' ? ssoClickNew('optumrx') : ssoClickNew('esi', 'orderrx')"
                href="#"
                class="btn btn-primary btn-sb-red mt-2"
                :title="buttonTitle(healthplanD.provider)"
            >
                {{ SsoButtonText(healthplanD.provider) }}
            </a>
        </div>
        <div class="row mt-4">
            <div v-if="field.fieldgroup !== 'contact' && field.fieldtype === 'heading2'"
                 :class="SsoButtonText(healthplanD.provider) ? 'col-lg-8' : 'col-lg-12'" v-for="field in healthplanD.hpd_fields[0].children"
            >
                <div class="card border-0">
                    <div class="card-header">
                        <span>{{ field.label }}</span>
                    </div>
                    <div class="card-body gray-bg">
                        <ul class="list-group mb-3">
                            <li class="list-group-item border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2">
                                <div class="row">
                                    <div class="col-md-7 sb-benefit-main-list-title pl-4">
                                        Plan Name
                                    </div>
                                    <div class="col-md-5 text-right sb-benefit-main-list-value">
                                        {{healthplanD.planname}}
                                    </div>
                                </div>
                            </li>
                            <li class="list-group-item border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2 not-sub">
                                <div class="row">
                                    <div class="col-md-7 sb-benefit-main-list-title pl-4 notsub">
                                        Pharmacy Benefit Provider
                                    </div>
                                    <div class="col-md-5 text-right sb-benefit-main-list-value">
                                        {{ getProvider(healthplanD.provider)}}
                                    </div>
                                </div>
                            </li>

                            <div v-for="subfield in field.children">
                                <li v-if="subfield.fieldtype === 'heading3' && showSubfield(subfield)"
                                    class="list-group-item border-top-0 border-bottom-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2"
                                >
                                    <div class="row">
                                        <div class="col-md-12 sb-benefit-main-list-title pl-4 text-uppercase">
                                            {{ subfield.label }}
                                        </div>
                                    </div>
                                </li>
                                <li v-else-if="subfield.label === 'Notes'"
                                    class="list-group-item border-top-0 border-right-0 border-left-0 border-bottom-0"
                                >
                                    <div class="card-notes">
                                        <div class="card-notes-title pt-2">NOTES:</div>
                                        <div class="card-notes-text" v-html="subfield.value"></div>
                                    </div>
                                </li>
                                <li v-else-if="showSubfield(subfield)"
                                    class="list-group-item border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2"
                                >
                                    <div class="row">
                                        <div class="col-md-7 sb-benefit-main-list-title pl-4">
                                            {{ subfield.label }}
                                        </div>
                                        <div class="col-md-5 text-right sb-benefit-main-list-value">
                                            {{ getTypeValue(subfield) }}
                                        </div>
                                    </div>
                                </li>
                                <template v-if="subfield.children.length > 0" v-for="sub in subfield.children">
                                <li v-if="showSub(sub)"
                                    class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0"
                                >
                                    <div class="row border-bottom mr-2" v-if="sub.fieldtype === 'heading3'">
                                        <div class="col-md-5 sb-benefit-main-list-title pb-2 text-uppercase">
                                            {{ sub.value }}
                                        </div>
                                    </div>
                                    <div class="row border-bottom mr-0" v-else>
                                        <div class="col-md-7 sb-benefit-main-list-title pl-4">
                                            {{ sub.label }}
                                        </div>
                                        <div class="col-md-5 text-right sb-benefit-main-list-value">
                                            {{ getTypeValue(sub) }}
                                        </div>
                                    </div>

                                    <ul class="list-group pr-2" v-if="sub.children.length>0"
                                        v-for="subsub in sub.children">
                                        <li class="list-group-item border-top-0 border-left-0 border-right-0 sb-benefit-sublist-value pt-2 pb-2" v-if="subsub.value !== ''">
                                            <div class="row">
                                                <div class="col-md-7 sb-benefit-main-sublist-title pl-0">
                                                    {{ subsub.label }}
                                                </div>
                                                <div class="col-md-5 text-right sb-benefit-main-list-value pr-1">
                                                    {{ getTypeValue(subsub) }}
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                                </template>
                            </div>
                            <li v-if="healthplanD.note" class="list-group-item border-top-0 border-right-0 border-bottom-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 mr-2">
                                <div class="card-notes" v-if="healthplanD.note">
                                    <div class="card-notes-title pt-2">NOTES:</div>
                                    <div class="card-notes-text" v-html="healthplanD.note"></div>
                                </div>
                            </li>
                        </ul>
                        <div class="card-forms">
                            <div class="card-forms-title pt-1">FORMS & BROCHURES</div>
                            <div class="card-forms-link">
                                <a v-for="fb in healthplanD.hpd_fb"
                                   :href="fb.value"
                                   :title="fb.name"
                                   :target="fb.name=='Decrease or Cancel Coverage'?'_self':'_blank'"
                                >{{ fb.name }}</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-lg-4 d-md-none" v-if="SsoButtonText(healthplanD.provider)">
<!--            OptumRx     -->
                <div v-if="healthplanD.provider === 'OptumRx' && envoptum=='on'" class="planRX">
                    <div class="planRX-link planRX-link__presc">
                        <a href="https://prf-new.optumrx.com/secure/medication-list" title="Redirect to Optum">
                            View my prescriptions
                        </a>
                    </div>
                    <div class="planRX-link planRX-link__locate">
                        <a href="https://prf-new.optumrx.com/secure/pharmacy-locator" title="Redirect to Optum">
                            Locate a pharmacy
                        </a>
                    </div>
                    <div class="planRX-link planRX-link__price">
                        <a href="https://prf-new.optumrx.com/secure/drug-pricing" title="Redirect to Optum">
                            Price your medication
                        </a>
                    </div>
                    <div class="planRX-link planRX-link__save">
                        <a href="https://prf-new.optumrx.com/secure/savings-center" title="Redirect to Optum">
                            Savings center
                        </a>
                    </div>
                </div>
<!--            All except OptumRx     -->
                <div v-else-if="healthplanD.provider !== 'OptumRx'" class="planRX">
                    <div class="planRX-link planRX-link__presc"><a href="#" @click="ssoClickNew('esi','prescriptions')" title="Redirect to Express Scripts">View my prescriptions</a></div>
                    <div class="planRX-link planRX-link__order"><a href="#" @click="ssoClickNew('esi','orderstatus')" title="Redirect to Express Scripts">Check order status</a></div>
                    <div class="planRX-link planRX-link__locate"><a href="#" @click="ssoClickNew('esi','locatepharmacy')" title="Redirect to Express Scripts">Locate a pharmacy</a></div>
                    <div class="planRX-link planRX-link__price"><a href="#" @click="ssoClickNew('esi','rxpricing')" title="Redirect to Express Scripts">Price your medication</a></div>
                    <div class="planRX-link planRX-link__save"><a href="#" @click="ssoClickNew('esi','rxpricing')" title="Redirect to Express Scripts">Save with my Rx Choices</a></div>
                    <div class="planRX-link planRX-link__enroll"><a href="#" @click="ssoClickNew('esi','Trasnsfertomail')" title="Redirect to Express Scripts">Enroll in home delivery</a></div>
                </div>
            </div>
        </div>
        <plan-contacts :contacts="healthplanD.hpc" title="Prescription Drug (Rx) Contact Information"></plan-contacts>
<!--       only mobile-->
        <div class="col-lg-4 p-0 mb-5 d-lg-none" v-if="SsoButtonText(healthplanD.provider)">
            <div class="planRX">
                <div class="planRX-link planRX-link__presc"><a href="#" @click="ssoClickNew('esi','prescriptions')" title="Redirect to Express Scripts">View my prescriptions</a></div>
                <div class="planRX-link planRX-link__order"><a href="#" @click="ssoClickNew('esi','orderstatus')" title="Redirect to Express Scripts">Check order status</a></div>
                <div class="planRX-link planRX-link__locate"><a href="#" @click="ssoClickNew('esi','locatepharmacy')" title="Redirect to Express Scripts">Locate a pharmacy</a></div>
                <div class="planRX-link planRX-link__price"><a href="#" @click="ssoClickNew('esi','rxpricing')" title="Redirect to Express Scripts">Price your medication</a></div>
                <div class="planRX-link planRX-link__save"><a href="#" @click="ssoClickNew('esi','rxpricing')" title="Redirect to Express Scripts">Save with my Rx Choices</a></div>
                <div class="planRX-link planRX-link__enroll"><a href="#" @click="ssoClickNew('esi','Trasnsfertomail')" title="Redirect to Express Scripts">Enroll in home delivery</a></div>
            </div>
        </div>
<!--        -->
        <div id="sso-esi" v-html="ssoEsi" ref="ssoEsi"></div>
    </div>
</template>

<script>
import _ from "lodash";
import PlanContacts from "./PlanContacts";

export default {
    name: "PlanRx",
    components: {PlanContacts},
    props: ['healthplanD','envoptum'],
    data() {
        return {
            ssoEsi: '',
            ssoEsiData: '',
        }
    },
    methods: {
        getWebsite(healthplan) {
            return _.filter(healthplan.hpc, {type: "website"})[0].website.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
        },
        getTypeValue(sub) {
            return {
                'currency': '$'+`${sub.value}`,
                'percent': `${sub.value}%`
            }[sub.type] || sub.value;
        },
        SsoButtonText(provider) {
            return this.$parent.ssoButtonText(provider);
        },
        showSub(sub) {
            if (sub.value !== '')
                return true;

            return !!sub.children.find(c => c.value !== '');
        },
        showSubfield(sub) {
            if (sub.value !== '')
                return true;

            return !!sub.children.find(c => this.showSub(c));
        },
        // ssoEsiClick(path) {
        //     document.getElementById("overlay").style.display = "flex";
        //     axios
        //         .get('/api/sso/esi/' + path)
        //         .then(res => {
        //             this.ssoEsi = res.data.html;
        //         }).then(() => {
        //         // this.$refs.ssoEsi.children[3].target = '_blank';
        //         this.$refs.ssoEsi.children[3].submit();
        //         document.getElementById("overlay").style.display = "none";
        //     });
        // },
        getProvider(provider) {
            return provider === 'ESI' ? 'Express Scripts' : provider;
        },
        ssoClickNew(provider, path = '') {
            if (provider.toLowerCase() === 'esi') {
                // Open Express Scripts URL for 'esi' provider
                window.open('https://www.express-scripts.com', '_blank');
            } else {
                const newPath = path ? `&path=${path}` : '';
                const baseUrl = `${window.location.origin}/dashboard`;
                window.open(`${baseUrl}?provider=${provider.toLowerCase()}${newPath}`, '_blank');
            }
        },
        // ssoClick(provider) {
        //     document.getElementById("overlay").style.display = "flex";
        //     axios.get('/api/sso/' + provider)
        //         .then(res => this.ssoEsi = res.data.html)
        //         .then(() => {
        //             // this.$refs.ssoEsi.children[3].target = '_blank';
        //             this.$refs.ssoEsi.children[3].submit();
        //         })
        //         .finally(() => document.getElementById("overlay").style.display = "none");
        // },
        buttonTitle(provider) {
            return 'Redirect to ' + (provider === 'OptumRx' ? 'Optum Rx' : 'Express Scripts');
        }
    }
}
</script>

<style scoped>

</style>
